import styled from 'styled-components';

/**
 * Thin draggable divider rendered between the sessions sidebar and the
 * chat pane in the bottom-tab terminal, and on the left edge of the
 * side-panel mount.
 *
 * Anchored to the parent at `style={{ left: <px> }}` (parent is a
 * `position: relative` flex row, so the absolute positioning slots into
 * the gap between the two columns). The visible bar is 2px; the
 * `::before` pseudo widens the pointer hit area to ~10px so the user
 * doesn't have to pixel-hunt.
 */
const SIDEBAR_RESIZE_HANDLE_WIDTH = 2;

export const SidebarResizeHandle = styled.div<{
  readonly $dragging: boolean;
}>`
  position: absolute;
  z-index: 4;
  top: 0;
  bottom: 0;
  width: ${SIDEBAR_RESIZE_HANDLE_WIDTH}px;
  margin-left: -${SIDEBAR_RESIZE_HANDLE_WIDTH / 2}px;
  cursor: ew-resize;
  touch-action: none;

  transition: background-color 0.2s ease;
  background-color: ${({ $dragging }) =>
    $dragging ? 'rgba(255, 255, 255, 0.1)' : 'transparent'};
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &::before {
    content: '';
    position: absolute;
    left: -4px;
    top: 0;
    bottom: 0;
    width: 10px;
  }
`;
